//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SlidePanel from "@/components/common_slidePanel.vue";
import PageBtns from "@/components/common_pageBtns.vue";
import FlexList from "@/components/common_flexList.vue";
import SearchBar from "@/components/common_searchBar.vue";
export default {
  name: '',
  components: { PageBtns, SlidePanel, FlexList, SearchBar },
  data () {
    return {
      btnConfig: {
        list: [ {text:'返回', type: 'primary', action: () => this.$router.go(-1)} ],
      },
      searchBarConfig: {placeholder: '请输入手机号'},
      sliderConfig: {
        isShow: false,
        formConfig: {list:[
          { type: 'input', title: '手机号', placeholder: '请输入订单号', no_arrow: true },
          { type: 'input', title: '订单号', placeholder: '请输入产品批次', no_arrow: true },
          { type: 'date', title: '生产日期', value:'', placeholder: '年/月/日', no_arrow: true },
          { type: 'date', title: '至', value: '',placeholder: '年/月/日', no_arrow: true },
          { type: 'date', title: '制单时间', value:'', placeholder: '年/月/日', no_arrow: true },
          { type: 'date', title: '至', value: '',placeholder: '年/月/日', no_arrow: true },
        ]},
      },
      flexList:[
        {
          topL:'1.SO1906262054561187', topR:'处理完毕', 
          bottomL: '2019-03-18 20:04:07', bottomR: '1个',
          link: '/DoraSms/ShopStockOutSalesOrder/Detail'
        },
        {
          topL:'2.SO1906262054561187', topR:'处理完毕', 
          bottomL: '2019-03-18 20:04:07', bottomR: '1个',
          link: '/DoraSms/ShopStockOutSalesOrder/Detail'
        },
        {
          topL:'3.SO1906262054561187', topR:'处理完毕', 
          bottomL: '2019-03-18 20:04:07', bottomR: '1个',
          link: '/DoraSms/ShopStockOutSalesOrder/Detail'
        },
      ],
    }
  },
  props: [],
  computed: {},
  methods: {
  }
}
